import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-29801ce4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "add-tenant"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "租户名称：", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "连锁：", -1));
const _hoisted_6 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_7 = {
  class: "pagination-box"
};
import { getAllTenantData, delTenant } from '@/api/tenant';
import { ElMessageBox, ElMessage } from 'element-plus';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { Search, Refresh } from '@element-plus/icons-vue';
import AddTenantUser from '@/components/TenantUser';
import { indexMethod } from '@/utils/indexMethod';
import Tenant from './Tenant';
import CounselorMenu from './CounselorMenu';
export default {
  __name: 'TenantContent',
  props: {
    activeName: {
      type: String
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    // 数据相关
    const allTenantData = ref([]);
    const total = ref(0);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const keyword = ref('');
    const isChain = ref('');
    const loading = ref(false);
    const getAllTenant = async () => {
      loading.value = true;
      const res = await getAllTenantData({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        isParent: 1,
        keyword: keyword.value,
        isChain: isChain.value
      });
      allTenantData.value = res.records;
      allTenantData.value.forEach(e => {
        e.workTime = e.workTime ? e.workTime.split('-') : [];
      });
      total.value = res.total;
      loading.value = false;
    };
    watch(() => props.activeName, val => {
      if (val === '门诊信息') return;
      getAllTenant();
    }, {
      immediate: true
    });
    const handleSearchActivity = () => {
      currentPage.value = 1;
      getAllTenant();
    };
    const handleRefreshActivity = async () => {
      currentPage.value = 1;
      pageSize.value = 10;
      keyword.value = '';
      isChain.value = '';
      await getAllTenant();
    };
    const handleCurrentChange = val => {
      currentPage.value = val;
      getAllTenant();
    };
    const searchClinic = row => {
      router.push(`/tenant/manage/${row.id}`);
    };
    const delTenantHandler = async row => {
      try {
        await ElMessageBox.confirm('确认删除吗', '温馨提示', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });
        const res = await getAllTenantData({
          parentId: row.id
        });
        // 如果该租户的子诊所数量为0的话
        if (!res.records.length) {
          await delTenant(row.id);
          await getAllTenant();
          ElMessage({
            message: '删除成功',
            type: 'success'
          });
        } else {
          ElMessage({
            message: '删除失败,该租户还有子诊所',
            type: 'warning'
          });
        }
      } catch (error) {
        console.log(`error: ${error}`);
      }
    };
    const handleApproval = row => {
      router.push(`/application/his?tenantId=${row.id}`);
    };
    const current = ref(null);
    const dialogTenantVisible = ref(false);
    const dialogCounselorMenuVisible = ref(false);
    const addTenantHandler = () => {
      dialogTenantVisible.value = true;
    };
    const editTenantHandler = row => {
      dialogTenantVisible.value = true;
      current.value = row;
    };

    // const handleUpdateCounselorMenu = (row) => {
    //   dialogCounselorMenuVisible.value = true
    //   current.value = row
    // }

    const currentTenantId = ref(0); // 当前租户id

    const currentClinicId = ref(''); // 当前诊所id

    const currentWxUser = ref(null);
    const clearModel = () => {
      currentTenantId.value = 0;
      currentClinicId.value = '';
      currentWxUser.value = null;
      currentTenantUser.value = null;
    };

    // 添加租户用户
    const isAddTenantUserShow = ref(false); // show or hide

    const currentTenantUser = ref(null);
    const viewTenantUser = row => {
      router.push(`/tenant/user/${row.id}`);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
          placeholder: "请输入租户名",
          style: {
            "width": "200px"
          }
        }, null, 8, ["modelValue"]), _hoisted_4, _hoisted_5, _createVNode(_component_el_select, {
          modelValue: isChain.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => isChain.value = $event),
          style: {
            "width": "200px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
            label: '连锁',
            value: 1
          }, {
            label: '非连锁',
            value: 0
          }], item => {
            return _createVNode(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: handleSearchActivity
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefreshActivity
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: addTenantHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })), [[_directive_permission, ['tenantAdd']]])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: true,
          data: allTenantData.value,
          style: {
            "width": "100%"
          },
          "row-key": "id"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "序号",
            type: "index",
            width: "100",
            align: "center",
            index: index => _unref(indexMethod)(index, currentPage.value, pageSize.value)
          }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
            prop: "id",
            label: "租户id",
            align: "center",
            width: "100"
          }), _createVNode(_component_el_table_column, {
            label: "诊所名",
            width: "380",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(row.name) + " ", 1), row.fsTenantId ? (_openBlock(), _createBlock(_component_svg_icon, {
              key: 0,
              class: "icon-class",
              icon: "new-lark"
            })) : _createCommentVNode("", true), row.wxUserId ? (_openBlock(), _createBlock(_component_svg_icon, {
              key: 1,
              class: "icon-class",
              icon: "wechat"
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "domainCode",
            label: "二级域名标识",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            prop: "statusName",
            label: "是否连锁",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(!!parseInt(row.isChain) ? '是' : '否'), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "创建时间",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "450"
          }, {
            default: _withCtx(({
              row
            }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "success",
              size: "small",
              onClick: $event => searchClinic(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 查看子诊所 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['clinicManage']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "info",
              size: "small",
              onClick: $event => viewTenantUser(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 查看租户用户 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['tenantUser']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => editTenantHandler(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['tenantUpdate']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => delTenantHandler(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['tenantDelete']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => handleApproval(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 授权 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['tenantDelete']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": currentPage.value,
          "page-size": pageSize.value,
          total: total.value,
          layout: "total,  prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), isAddTenantUserShow.value ? (_openBlock(), _createBlock(_unref(AddTenantUser), {
        key: 0,
        modelValue: isAddTenantUserShow.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => isAddTenantUserShow.value = $event),
        tenantId: currentTenantId.value,
        onClearModel: clearModel,
        model: currentTenantUser.value
      }, null, 8, ["modelValue", "tenantId", "model"])) : _createCommentVNode("", true), _createVNode(_unref(Tenant), {
        model: current.value,
        modelValue: dialogTenantVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogTenantVisible.value = $event),
        onData: getAllTenant,
        onClearModel: _cache[4] || (_cache[4] = $event => current.value = null)
      }, null, 8, ["model", "modelValue"]), _createVNode(_unref(CounselorMenu), {
        model: current.value,
        modelValue: dialogCounselorMenuVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => dialogCounselorMenuVisible.value = $event),
        onData: getAllTenant,
        onClearModel: _cache[6] || (_cache[6] = $event => current.value = null)
      }, null, 8, ["model", "modelValue"])]);
    };
  }
};